var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ColumnContent,
    { attrs: { title: _setup.t("Регионы", _setup.options) } },
    _vm._l(_setup.context.regions, function (region) {
      return _c(
        "a",
        {
          key: region.translit,
          staticClass:
            "d-table text--text link-decoration-none mb-4 text-body-1",
          attrs: {
            "data-qa": "region-link",
            href: `https://${_setup.context.request.country.site.domain}/${region.translit}/`,
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.transDynamic(
                  region,
                  `name,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }